<template>
  <div class="msc-ag-datetime-editor">
    <v-datetime-picker
      ref="picker"
      v-model="selected"
      :dialog-width="340"
      :text-field-props="textFieldProps"
      @input="onPickerInput"
      @keydown.stop
    >
      <template v-slot:dateIcon>
        <v-icon>mdi-calendar</v-icon>
      </template>
      <template v-slot:timeIcon>
        <v-icon>mdi-calendar-clock</v-icon>
      </template>
    </v-datetime-picker>
  </div>
</template>

<script>
const parseDisplayToDate = (displayValue) => {
  const value = String(displayValue || '').trim();
  if (!value) return null;
  const m = value.match(/^(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2})$/);
  if (!m) return null;
  const [, dd, mm, yyyy, hh, min] = m;
  return new Date(Number(yyyy), Number(mm) - 1, Number(dd), Number(hh), Number(min));
};

const formatDateToDisplay = (date) => {
  if (!date || !(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export default {
  name: 'MscReportDateTimeCellEditor',
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    textFieldProps() {
      return {
        dense: true,
        hideDetails: true,
        readonly: true,
        placeholder: 'dd-mm-yyyy HH:mm',
        'prepend-inner-icon': 'mdi-calendar',
      };
    },
  },
  mounted() {
    this.selected = parseDisplayToDate(this.params && this.params.value);
    this.$nextTick(() => this.openPicker());
  },
  methods: {
    openPicker() {
      const input = this.$refs.picker && this.$refs.picker.$el
        && this.$refs.picker.$el.querySelector('input');
      if (input) input.click();
    },
    afterGuiAttached() {
      this.$nextTick(() => this.openPicker());
    },
    commitEdit() {
      this.$nextTick(() => {
        if (this.params && typeof this.params.stopEditing === 'function') {
          this.params.stopEditing();
        }
      });
    },
    onPickerInput(val) {
      this.selected = val;
      this.commitEdit();
    },
    getValue() {
      return formatDateToDisplay(this.selected);
    },
  },
};
</script>

<style scoped>
.msc-ag-datetime-editor {
  height: 100%;
  min-width: 140px;
  padding: 2px 4px;
  width: 100%;
}

.msc-ag-datetime-editor >>> .v-input {
  margin-top: 0;
  padding-top: 0;
}
</style>
